import type { IncomingHttpHeaders } from 'http';

import logger from '@/logger';

export type WebhookConfig = {
    discountApplied?: number;
    endpoint?: string;
    promoCode?: string;
    quotedFare?: number;
    quotedFeeTotal?: number;
    requestHeaders?: IncomingHttpHeaders;
    revalidate?: number;
    userAgent?: string;
};
export async function webhook(config: WebhookConfig, payload: { [key: string]: any; }) {
    if (!config.endpoint) { return; }
    try {
        const URI = `${process.env.NEXT_PUBLIC_TRAILWAYS_WEBHOOK_URL}/hook/${config.endpoint}`;
        if (payload.response instanceof Response) {
          payload.response = await payload.response.clone().json();
        }
        const webhookPayload = {
            env: process.env.NEXT_PUBLIC_TRAILWAYS_WEBHOOK_ENV,
            site: process.env.NEXT_PUBLIC_TRAILWAYS_WEBHOOK_HOSTNAME,
            timestamp: new Date().toISOString(),
            payload: {
                ...payload,
                provider: "TDS",
            },
        };
        let headers = {
            "Accept": "application/json, text/plain, */*",
            "content-type": "application/json",
        };
        if (config.userAgent) {
            Object.defineProperty(headers, 'User-Agent', { value: config.userAgent });
        }
        const fetchConfig = {
            body: JSON.stringify(webhookPayload),
            headers: headers,
            keepalive: false,
            method: "POST",
            next: {
                revalidate: 0  // Webhooks shouldn't be cached
            }
        }
        await fetch(
            URI,
            fetchConfig
        );
    } catch (error: any) {
        if (error) {
            console.error(error.message);
        }
        logger.log('error', `Webhook error: ${error ? error.message : ''}`);
        return;
    }
}
